import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare `/admin/transitions` has no pane of its own — land on the stacked section.
export const Route = createFileRoute('/_app/admin/transitions/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/transitions/jobs' })
  },
})
